import { useSearchParams } from 'react-router-dom';
import {
  Chip,
  ChipItemValueItem,
  ChipItemValuesList,
  ChipSeparator,
  ChipItemFacet,
  ChipItemClose,
  ChipItem,
} from '@src/design-system/chip';
import { getChannelSvg } from '@src/shared/features/reminders/helpers/get-channel-svg';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import type { TReminderTemplate } from '@src/shared/types/reminder-template';

export default function ReminderChannelChip() {
  const [sp, setSp] = useSearchParams();
  const selectedChannel = sp.get('channel') as TReminderTemplate['channel'];

  if (!selectedChannel) return null;

  return (
    <Chip>
      <ChipItem className='h-[40px]'>
        <ChipItemClose
          onClick={() =>
            setSp((prev) => {
              prev.delete('channel');
              return prev;
            })
          }
        />
        <ChipItemFacet>Channel</ChipItemFacet>
        <ChipSeparator />
        <ChipItemValuesList>
          <ChipItemValueItem>
            <div className='size-4 mr-1'>
              <img
                src={getChannelSvg(selectedChannel)}
                alt={selectedChannel}
              />
            </div>

            {formatTextForDisplay(selectedChannel)}
          </ChipItemValueItem>
        </ChipItemValuesList>
      </ChipItem>
    </Chip>
  );
}
